import type { FaireProductEntity } from "../../entity_types/product";

export const p_9yuzwfyt5t: FaireProductEntity = {
  token: "p_9yuzwfyt5t",
  type: "product",
  name: "Calder Sweater Tee - Jacaranda",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/cc5bf3c95c61419cc11222685f41fd2e5c733131097f11492ecbe4955af09bbe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0fe65aec6adf459f5f7d069d4d2dd9f56383597b5f9b7feb6980a6f8622b25c.jpeg",
    "https://cdn.faire.com/fastly/0fae33168e2cd3daa909a687835e5c08f3904136359c415b35369c5ea1c74867.jpeg",
    "https://cdn.faire.com/fastly/2220eaef8b11805574dc4b7d7ef4ef0ff9cf872e3bbc3b679afb47e6995804a6.jpeg"
  ],
  priceDollars: 75.6,
  description: "The Calder Tee has a relaxed silhouette that holds its shape, sitting cleanly on the body with a clear, defined line. The cotton has a smooth, flat finish with minimal drape. It works equally well on its own or layered, making it a reliable piece year-round.\n\nInspired by painted tile work observed in Lima, the pattern introduces a new sense of rhythm and color while maintaining a clean, graphic foundation. The surface feels considered without overwhelming the form, allowing it to pair easily with a range of silhouettes, from tailored trousers to more voluminous skirts or dresses.\n\n• 100% cotton\n• Relaxed fit that holds its shape\n• Smooth, flat finish with minimal drape\n• Maintains a clean silhouette and resists wrinkling\n• Designed for year-round wear\n• Pairs well with trousers, denim, or layered over dresses and skirts",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:27.736Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
